import React from "react"
import { Link } from "gatsby"
import navItemStyles from "./navItems.module.scss"
import { headerNavLinks } from "../utils/navHelper"

const NavItems = () => {
  return (
    <ul>
      {headerNavLinks.map(({ text, to }) => (
        <li key={to}>
          <Link
            to={to}
            className={navItemStyles.navItem}
            activeClassName={navItemStyles.navItemActive}
          >
            {text}
          </Link>
        </li>
      ))}
    </ul>
  )
}

export default NavItems
